// A message's time, under the message. Re-renders itself at the reader's next midnight, so "14:32"
// becomes "Oct 07, 2026 14:32" on a page left open overnight.

import React, { useEffect, useState } from "react";
import { formatMessageTime, fullMessageTime, msUntilNextDay } from "../messageTime.mjs";
import styles from "../sqAi.module.css";

export default function MessageTime({ at, zone, side }) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (at == null) return undefined;
    const t = setTimeout(() => setNow(Date.now()), msUntilNextDay(now, zone));
    return () => clearTimeout(t);
  }, [at, zone, now]);

  const label = at == null ? null : formatMessageTime(at, { zone, now });
  if (!label) return null;
  return (
    <time
      className={`${styles.messageTime} ${side === "user" ? styles.messageTimeUser : styles.messageTimeAnswer}`}
      dateTime={new Date(typeof at === "string" ? Date.parse(at) : at).toISOString()}
      title={fullMessageTime(at, { zone })}
    >
      {label}
    </time>
  );
}
